import { configureStore } from '@reduxjs/toolkit';
import projectsReducer from 'redux-slices/projects-slice';
import currentProjectReducer from 'redux-slices/current-projects-slice';
import tasksReducer from 'redux-slices/tasks-slice';
import hourCardsReducer from 'redux-slices/hour-cards-slice';
import notesReducer from 'redux-slices/notes-slice';
import currentUserReducer from 'redux-slices/current-user-slice';
import projectPendingReducer from 'redux-slices/project-pending-slice';
import ongoingHourCardsReducer from 'redux-slices/ongoing-hour-cards-slice';

export const store = configureStore({
  reducer: {
    projects: projectsReducer,
    currentProject: currentProjectReducer,
    currentUser: currentUserReducer,
    tasks: tasksReducer,
    hourCards: hourCardsReducer,
    ongoingHourCards: ongoingHourCardsReducer,
    notes: notesReducer,
    projectPending: projectPendingReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
